import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightFromBracket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.9995 16L20.9995 12M20.9995 12L16.9995 8M20.9995 12H8.99951M12.9995 21H6.20029C5.08019 21 4.52014 21 4.09231 20.782C3.71599 20.5903 3.41003 20.2843 3.21828 19.908C3.00029 19.4802 3.00029 18.9201 3.00029 17.8V6.2C3.00029 5.0799 3.00029 4.51984 3.21828 4.09202C3.41003 3.71569 3.71599 3.40973 4.09231 3.21799C4.52014 3 5.08019 3 6.20029 3L12.9995 3",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRightFromBracket;
